import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import {
  selectIsLoading,
  selectReportData,
} from '../../../common/order/businessCreditReport/store/slice'
import { getReportItems } from '../../../common/order/businessCreditReport/store/thunk'
import {
  BLANK_OPTION,
  mapCurrency,
} from '../../../common/order/popup/popupConfirmationBuyNowOrAddCart/constants'
import { addToCart } from '../../../common/order/popup/popupConfirmationBuyNowOrAddCart/store/thunk'
import { PopupAction } from '../../../common/popup/PopupAction'
import { formatText } from '../../../helpers/value'
import {
  BUSINESS_REPORT_TYPE_SELECT,
  VERSION_REPORT,
  VERSION_TYPE_SELECT,
} from '../../constant'
import { changeFragment } from '../../store/slice'
import { ItemSelect } from './ItemSelect'

const keySelect = {
  type: 1,
  version: 2,
  currency: 3,
  additional: 4,
}

export const PopupChangeBusinessReport = ({ onClose, isShow, data }) => {
  const dispatch = useDispatch()

  const loading = useSelector(selectIsLoading)
  const reportData = useSelector(selectReportData)

  const [activeItem, setActive] = useState({
    [keySelect.type]: {
      label: data?.reportType,
      value: data?.idTypeReport,
    },
    [keySelect.version]: VERSION_TYPE_SELECT[data?.version ? 1 : 0],
    [keySelect.currency]: {
      label: 'VND',
      value: undefined,
    },
    [keySelect.additional]: {
      label: data?.additionalCurrency,
      value: data?.additionalCurrency,
    },
  })

  const isDisableSelectVersion = useMemo(() => {
    return reportData.find(
      (item) => item?.fiinGateReportTypeId === activeItem[keySelect.type].value,
    )
  }, [activeItem[keySelect.type].value, reportData.length])

  const onSubmit = () => {
    dispatch(
      addToCart({
        cartItems: [
          {
            id: data?.id,
            readyVersion: activeItem[keySelect.version].value,
            fiinGateReportTypeId: activeItem[keySelect.type].value,
            additionalCurrencyCode: activeItem[keySelect.additional].value,
            organizationId: data?.organizationId,
            availableData: data?.availableData,
          },
        ],
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeFragment())
        onClose()
      })
      .catch(() => {})
  }

  useEffect(() => {
    dispatch(getReportItems({ OrganizationId: data?.organizationId }))
  }, [])

  useEffect(() => {
    if (
      !isDisableSelectVersion?.hasReadyVersion &&
      activeItem[keySelect.version].value
    ) {
      setActive((prev) => ({
        ...prev,
        [keySelect.version]: {
          label: VERSION_REPORT.REQUEST,
          value: false,
          isI18n: true,
        },
      }))
    }
  }, [activeItem[keySelect.type].value])

  return (
    <PopupAction
      appendStyle={{
        padding: '20px',
        backgroundColor: '#F3F3F3',
        width: 420,
        borderRadius: '4px',
      }}
      isShow={isShow}
      title="cartAndOrders.main.variations"
      handleClose={onClose}
      btnSubmit={{
        label: 'cartAndOrders.tradeDiscount.apply',
        event: onSubmit,
        isI18n: true,
      }}
      btnCancel={{
        label: 'cartAndOrders.tradeDiscount.cancel',
        event: onClose,
        isI18n: true,
      }}
    >
      <div className="positionRelative h100">
        {loading && <Loading />}
        <div className="h100" style={{ opacity: loading ? 0 : 1 }}>
          <Element className="fw600 py1" style={{ fontSize: 14 }}>
            {formatText(data?.reportType)}
          </Element>
          <Element
            className="fw600 py1"
            style={{ color: '#0553A5', paddingTop: 12 }}
          >
            {formatText(data?.companyName)}
          </Element>
          <div className="flexColumn gap2">
            <ItemSelect
              data={BUSINESS_REPORT_TYPE_SELECT}
              label="cartAndOrders.main.reportType"
              activeItem={activeItem[keySelect.type]}
              setActive={setActive}
              keySelect={keySelect.type}
            />
            <ItemSelect
              data={VERSION_TYPE_SELECT.map((item, index) => ({
                ...item,
                disabled:
                  !isDisableSelectVersion?.hasReadyVersion && index === 1
                    ? true
                    : false,
              }))}
              label="cartAndOrders.main.version"
              activeItem={activeItem[keySelect.version]}
              setActive={setActive}
              keySelect={keySelect.version}
              isI18n
            />
            <ItemSelect
              data={[
                {
                  label: 'VND',
                  value: undefined,
                },
              ]}
              label="cartAndOrders.main.currency"
              activeItem={activeItem[keySelect.currency]}
              setActive={setActive}
              keySelect={keySelect.currency}
              isI18n
              disabled
            />
            <ItemSelect
              data={[BLANK_OPTION, mapCurrency.USD, mapCurrency.EUR]}
              label="cartAndOrders.main.additional"
              activeItem={activeItem[keySelect.additional]}
              setActive={setActive}
              keySelect={keySelect.additional}
            />
          </div>
        </div>
      </div>
    </PopupAction>
  )
}
